import ContentModule from './content.module'

export default ContentModule
